import s from "./news.module.css";
import BuyButton from "../../assets/Components/StyledComponents/BuyButton";
import {NavLink} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setNew} from "../../store/SetNewsSlice";


const NewsItem = (props) => {
    const dispatch = useDispatch();


    return (
        <div className={s.newsItem}>
            <img src={props.img} alt=""/>
            <div className={s.itemInfo}>
                <h5>{props.title}</h5>
                <span>{props.day}</span>
                <p>{props.post}</p>
                <NavLink to="new" onClick={() => dispatch(setNew({
                    title: props.title,
                    day: props.day, post: props.post, img: props.img
                }))}><BuyButton>ПОДРОБНЕЕ</BuyButton></NavLink>
            </div>
        </div>
    )
}

export default NewsItem;